import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import DropdownMenu from '../../shared/dropdownMenu';

class HamburgerDropdown extends PureComponent {
  static propTypes = {
    additionalItems: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node,
    ]),
  };

  hideDropDown = () => {
    this.dropdown.hideDropDown();
  };

  render() {
    return (
      <DropdownMenu ref={dropdown => this.dropdown = dropdown} contentClassName="hamburger-menu">
        {this.props.additionalItems}
      </DropdownMenu>
    );
  }
}

export default HamburgerDropdown;
